// Reserves the same footprint a real ProductGrid("2-3-4") occupies, so a
// page that fetches its product list asynchronously doesn't render at zero
// height and then jump once data arrives — that jump shoves everything
// below it (portfolio section, footer) down, which counts as a real CLS
// event, not just a visual flash. Shape mirrors ProductCard closely enough
// (aspect-[4/3] image area + a few text-line placeholders) that the
// reserved height is a close match to the real card.
export default function ProductGridSkeleton({ count }: { count: number }) {
  return (
    <div className="flex flex-wrap pl-px pt-px" aria-hidden="true">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="-ml-px -mt-px w-1/2 sm:w-1/3 xl:w-1/4">
          <div className="flex h-full flex-col border border-steel-200 bg-white">
            <div className="aspect-[4/3] animate-pulse bg-steel-100" />
            <div className="flex flex-1 flex-col gap-2 p-3 sm:p-6">
              <div className="h-3 w-1/3 animate-pulse bg-steel-100" />
              <div className="h-4 w-full animate-pulse bg-steel-100" />
              <div className="mt-auto h-4 w-1/2 animate-pulse bg-steel-100" />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
